import { format, formatDistanceToNow, parseISO } from 'date-fns';

export const formatOdds = (value) => {
  if (!value && value !== 0) return '-';
  return Number(value).toFixed(2);
};

export const formatPercent = (value) => {
  if (!value && value !== 0) return '-';
  const num = Number(value);
  const sign = num > 0 ? '+' : '';
  return `${sign}${num.toFixed(2)}%`;
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    return format(parseISO(dateStr), 'MMM dd, yyyy');
  } catch {
    return dateStr;
  }
};

export const formatTime = (dateStr) => {
  if (!dateStr) return '';
  try {
    return format(parseISO(dateStr), 'HH:mm');
  } catch {
    return '';
  }
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return '';
  try {
    return format(parseISO(dateStr), 'MMM dd, yyyy HH:mm');
  } catch {
    return dateStr;
  }
};

export const formatRelative = (dateStr) => {
  if (!dateStr) return '';
  try {
    return formatDistanceToNow(parseISO(dateStr), { addSuffix: true });
  } catch {
    return dateStr;
  }
};

export const formatMoney = (value, currency = 'USD') => {
  if (!value && value !== 0) return '-';
  return `${Number(value).toFixed(2)} ${currency}`;
};

export const getOddsChangeClass = (change) => {
  if (!change) return '';
  return change > 0 ? 'odds-up' : change < 0 ? 'odds-down' : '';
};
